import React, { memo } from "react"
import styled from "styled-components"
import clsx from "clsx"
import EmailCardHeader from "./EmailCardHeader"
import Heading from "components/Typography/Heading"
import Caption from "components/Typography/Caption"

const EmailCardContainer = styled.div<{ bgColor: string; colorSecondary: string }>`
  max-width: 226px;
  width: 100%;
  height: 293px;
  border-radius: 12px;
  border: 1px solid ${(props) => props.bgColor};
  background-color: ${(props) => props.theme.palette.white};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  .email-title {
    color: ${(props) => props.bgColor};
  }

  .email-button {
    background-color: ${(props) => props.bgColor};

    &.gradient {
      background: linear-gradient(135deg, ${(props) => props.bgColor} 0%, ${(props) => props.colorSecondary} 100%);
    }
  }
`

const EmailCardContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px 16px 12px 16px;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
`

const EmailTitle = styled.div`
  display: flex;
  margin-top: 8px;
`

const Placeholder = styled.div`
  background-color: ${(props) => props.theme.palette.gray_light};
  height: 12px;
`

const PlaceholdersContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const PlaceholderOne = styled(Placeholder)`
  width: 80%;
  margin-top: 28px;
`

const PlaceholderTwo = styled(Placeholder)`
  width: 100%;
  margin-top: 8px;
`

const PlaceholderThree = styled(Placeholder)`
  width: 70%;
  margin-top: 24px;
`

const PlaceholderFour = styled(Placeholder)`
  width: 60%;
  margin-top: 4px;
`

const EmailButton = styled.div`
  width: 100%;
  height: 30px;
  border-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: auto;
`

interface EmailCardProps {
  color: string
  colorSecondary: string
  isGradient: boolean
  logoFile: File | undefined
  logoUrl: string
}

const EmailCard: React.FC<EmailCardProps> = (props: EmailCardProps) => {
  const { color, colorSecondary, isGradient, logoFile, logoUrl } = props

  return (
    <EmailCardContainer bgColor={color} colorSecondary={colorSecondary} className={clsx({ gradient: isGradient })}>
      <EmailCardHeader logoFile={logoFile} logoUrl={logoUrl} />
      <EmailCardContent>
        <EmailTitle>
          <Heading variant="h5" className={clsx("email-title", { gradient: isGradient })}>
            Boas vindas!
          </Heading>
        </EmailTitle>
        <PlaceholdersContainer>
          <PlaceholderOne />
          <PlaceholderTwo />
          <PlaceholderThree />
          <PlaceholderFour />
        </PlaceholdersContainer>
        <EmailButton className={clsx("email-button", { gradient: isGradient })}>
          <Caption size="large" weight="semi-bold" color="white">
            Apenas texto
          </Caption>
        </EmailButton>
      </EmailCardContent>
    </EmailCardContainer>
  )
}

export default memo(EmailCard)
